<template >
  <div>
    <el-upload
      v-if="isShow"
      ref="upload"
      :file-list="questionFiles"
      :auto-upload="true"
      :data="access"
      :action="action"
      list-type="picture"
      :multiple="false"
      :before-upload="beforeUpload"
      :on-remove="onRemoveHandler"
      :before-remove="beforeRemove"
      :on-success="onSuccessHandler"
      :on-error="onError"
      :on-preview="handlePreview"
      :disabled="IsUpload==false"
    >
      <el-button size="small" type="primary" v-if="IsUpload" :disabled="IsShowUpload">点击上传</el-button>
    </el-upload>
    <!-- <source-preview :data.sync="sourceUrl"></source-preview> -->
    <!--课件预览-->
    <div class="PreviewResourcces" v-show="dialogVisiblePreviewResources">
      <!-- <i @click="dialogClose()" style="color:red;" class="el-icon-close yl-source-preview-show-close-wrapper"></i> -->
      <!-- <i v-if="auth.userType == 1" @click="dialogClose()" style="color:red;" class="el-icon-close yk-stu-preview-source-close-wrapper"></i> -->
      <PreparingCourseware
        v-if="dialogVisiblePreviewResources"
        :sourceId="docId"
        :savesession="false"
        @dialogVisiblePreviewResources="dialogClose()"
      ></PreparingCourseware>
    </div>
  </div>
</template>

<script>
// import Vue from 'vue';
import uploader from "lib/mixins/uploader";
import PreparingCourseware from "components/PreparingCourseware.vue";
export default {
  name: "oss-question-file",
  components: {
    // SourcePreview,
    PreparingCourseware
  },
  mixins: [uploader],
  props: {
    fileIds: {
      type: Array,
      default: ""
    },
    filesList: {
      type: Array,
      default: {
        Id: String,
        DocTitle: String,
        DocUrl: String,
        DocPrviewUrl: String
      }
    },
    IsUpload: {
      type: Boolean,
      default: true
    }
  },
  created() {
    this.filesList.sort();
  },
  computed: {
    auth() {
      let auth = this.$store.state.auth;
      return { ...auth };
    }
  },
  data() {
    return {
      docId: "",
      questionFiles: [],
      sourceUrl: {
        id: "",
        url: "",
        type: "",
        docName: "",
        docType: 0
      },
      removeids: [],
      dialogVisiblePreviewResources: false,
      IsShowUpload: false,
      defaultCover: require("assets/images/noCover.jpg"),
      xlsCover: require("assets/images/xls.png"),
      swfCover: require("assets/images/swf.png"),
      mp3Cover: require("assets/images/mp3.png"),
      zipCover: require("assets/images/zip.png"),
      isShow: true
    };
  },
  watch: {
    filesList: function(val) {
      this.questionFiles = [];
      this.removeids = [];
      let url = "";
      val.forEach(element => {
        // url = element.DocUrl==""?this.defaultCover:element.DocUrl;
        if (
          element.DocExtension === ".pdf" ||
          element.DocExtension === ".txt" ||
          element.DocExtension === ".ppt" ||
          element.DocExtension === ".pptx" ||
          element.DocExtension === ".doc" ||
          element.DocExtension === ".docx"
        ) {
          url =
            element.DocPrexUrl === "" ? this.defaultCover : element.DocPrexUrl;
        } else if (element.DocExtension === ".mp4") {
          url =
            element.DocUrl === ""
              ? this.defaultCover
              : element.DocUrl +
                "?x-oss-process=video/snapshot,t_10000,f_jpg,w_329,h_160";
        } else if (element.DocExtension === ".ziph") {
          url = this.defaultCover;
        } else if (
          element.DocExtension === ".xlsx" ||
          element.DocExtension === ".xls"
        ) {
          url = this.xlsCover;
        } else if (element.DocExtension === ".swf") {
          url = this.swfCover;
        } else if (element.DocExtension === ".mp3") {
          url = this.mp3Cover;
        } else if (
          element.DocExtension === ".rar" ||
          element.DocExtension === ".zip" ||
          element.DocExtension === ".7z"
        ) {
          url = this.zipCover;
        } else {
          url = element.DocUrl === "" ? this.defaultCover : element.DocUrl;
        }

        this.questionFiles.push({
          name: element.DocTitle,
          url: url,
          docId: element.Id
        });
        this.removeids.push(element.Id);
      });
      this.$emit("update:fileIds", this.removeids);
    },
    dialogVisiblePreviewResources: function(val) {
      this.$emit("Preview", val);
    }
  },
  methods: {
    uploadFile() {},
    dialogClose() {
      this.IsShowUpload = false;
      this.dialogVisiblePreviewResources = false;
    },
    beforeUpload(file) {
      this.IsShowUpload = true;
      return this.addFile(file);
    },
    onRemoveHandler(file) {
      // if (this.onRemove) {
      //   this.onRemove();
      // }
      this.questionFiles = this.questionFiles.filter(
        p => p.docId !== file.docId
      );
      this.removeids.splice(this.removeids.indexOf(file.docId), 1);
      this.removeids = this.removeids.filter(p => p !== file.docId);
      this.$emit("update:fileIds", this.removeids);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handlePreview(file) {
      this.dialogVisiblePreviewResources = true;
      this.docId = file.docId;
      // GetFileInfo(file.docId).then(rst => {
      //   if (rst.status == -1) {
      //     this.$message.warning("文件转换失败不能预览");
      //   } else if (rst.status == -2) {
      //     this.$message.warning("文件正在转换请稍后预览");
      //   } else if (rst.status == 1) {
      //     this.sourceUrl = {
      //       url: rst.docPriviewUrl,
      //       type: rst.type,
      //       docName: rst.docName,
      //       docType: rst.docType,
      //       id:file.docId
      //     };
      //   } else {
      //     this.$message.warning(rst.msg);
      //   }
      // });
    },
    onSuccessHandler(res, file, uploadFiles) {
      debugger;
      var that = this;
      this.IsShowUpload = false;
      var IsUpdate = false;
      for(let i = 0;i< uploadFiles.length -1 ;i++){
        if(uploadFiles[i].url.replace("https://file.clpp.org.cn","") == res.docPath.replace("https://zhykt.oss-cn-shanghai.aliyuncs.com","")){
          IsUpdate = true;
        }
      }
      if(IsUpdate){
        uploadFiles.splice(uploadFiles.length - 1, 1);
      }

      // 执行mixins里的onSuccess, 继续下一个文件
      if (this.onSuccess) {
        this.onSuccess(res, file, uploadFiles);
      }
      if (res.code > 0) {
        file.url = res.docPath;
      }
      this.$http.post('/api/XOrg/BookMaterial/getDocUrl',{
        Id:file.response.docId
      }).then(rst => {
        if (rst.code === 1) {
          let url = "";
          if (
            rst.courseWare.DocExtension === ".pdf" ||
            rst.courseWare.DocExtension === ".txt" ||
            rst.courseWare.DocExtension === ".ppt" ||
            rst.courseWare.DocExtension === ".pptx" ||
            rst.courseWare.DocExtension === ".doc" ||
            rst.courseWare.DocExtension === ".docx"
          ) {
            url =
              rst.courseWare.DocPrexUrl === ""
                ? this.defaultCover
                : rst.courseWare.DocPrexUrl;
          } else if (rst.courseWare.DocExtension === ".mp4") {
            url =
              rst.courseWare.DocUrl === ""
                ? this.defaultCover
                : rst.courseWare.DocUrl +
                  "?x-oss-process=video/snapshot,t_10000,f_jpg,w_329,h_160";
          } else if (rst.courseWare.DocExtension === ".ziph") {
            url = this.defaultCover;
          } else if (
            rst.courseWare.DocExtension === ".xlsx" ||
            rst.courseWare.DocExtension === ".xls"
          ) {
            url = this.xlsCover;
          } else if (rst.courseWare.DocExtension === ".swf") {
            url = this.swfCover;
          } else if (rst.courseWare.DocExtension === ".mp3") {
            url = this.mp3Cover;
          } else if (
            rst.courseWare.DocExtension === ".rar" ||
            rst.courseWare.DocExtension === ".zip" ||
            rst.courseWare.DocExtension === ".7z"
          ) {
            url = this.zipCover;
          } else {
            url =
              rst.courseWare.DocUrl === ""
                ? this.defaultCover
                : rst.courseWare.DocUrl;
          }
          if (!IsUpdate) {
            that.questionFiles.push({
              name: file.name,
              url: url,
              docId: res.docId
            });
            this.removeids.push(res.docId);
          } else {
            this.$message.error("不能上传相同文件!");
          }
        } else {
          this.questionFiles.push({
            name: file.name,
            url: res.docPath,
            docId: res.docId
          });
          this.removeids.push(res.docId);
        }
      });
      // this.questionFiles.push({
      //   name: file.name,
      //   url: res.docPath,
      //   docId: res.docId
      // });
      this.$emit("update:fileIds", this.removeids);
    }
  }
};
</script>

<style lang="scss">
.PreviewResourcces {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2010;
  background-color: rgba(0, 0, 0, 1);
  width: 100%;
  height: 100%;
  overflow: auto;
  .icon-closeimg {
    size: 26px;
    position: fixed;
    top: 20px;
    right: 20px;
    font-size: 35px;
    cursor: pointer;
    font-weight: bolder;
  }
}
</style>
